import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDistribution } from '../../../../hooks';
import { formatThousands } from '../../../../utils';
import { clearByModuleFromLocalStorage } from '../../../../store';
import { Exhibitor, VoucherType } from '../../../../dtos';
import { Button } from '../../../../components';
import { Container, Item } from './styles';

type Props = {
    exhibitor: Exhibitor;
    voucherTypes: VoucherType[];
}

const ExhibitorVouchersType: React.FC<Props> = ({ exhibitor, voucherTypes }) => {
    const navigate = useNavigate();
    const { clearDistributionState, selectVoucherType } = useDistribution();

    const navigateToDistributionPage = useCallback((type: VoucherType) => {
        clearDistributionState(false);
        clearByModuleFromLocalStorage('distribution');
        selectVoucherType(exhibitor, type);
        navigate('/distribution', {
            replace: true,
            state: {
                isBalance: false
            }
        });
    }, [navigate, clearDistributionState, selectVoucherType, exhibitor]);

    return (
        <Container>
            {voucherTypes.map((voucherType, index) => (
                <Item
                    id={`home.vouchertypes${index}.usebutton`}
                    key={index}
                    onClick={() => navigateToDistributionPage(voucherType)}
                >
                    <strong>{voucherType.name}</strong>
                    <span>{formatThousands(voucherType.amount)}</span>
                    <small>cortesias disponíveis</small>
                    <Button label>Usar</Button>
                </Item>
            ))}
        </Container>
    );
};

export { ExhibitorVouchersType };
